export default "__VITE_ASSET__cade389f__"